import MyFavoriteApi from '@/api/my/favorite';
import {useOutsideClick} from '@/components/main/common/hooks/useOutsideClick';
import {goToChannelViaAppScheme} from '@/components/starrank/mobile/StarRankMobileLayout';
import {isLogin} from '@/utils/main';
import throwToast from '@/utils/ui/toast';
import {useEffect, useState, useRef} from 'react';

/**
 * 별별랭킹 모바일 페이지, 방송 아이템 쓰리닷 메뉴 선택 시 표시 메뉴
 * @param {Object} props
 * @param {string} props.streamerId 스트리머 ID
 * @param {boolean} props.openIct 메뉴 표시 여부
 * @param {function} props.setOpenIct 메뉴 표시 설정 함수
 */
const StarRankMobileContextMenu = ({streamerId, openIct, setOpenIct}) => {
  const [isFavorite, setIsFavorite] = useState(false);

  const iconRef = useRef(null);

  const handleClickOutside = (e) => {
    e.stopPropagation();
    setOpenIct(false);
  };

  const onClickfavoriteBtn = async () => {
    if (!isLogin()) {
      throwToast('로그인후 시도하세요');
    } else {
      try {
        const favoriteAction = isFavorite
          ? MyFavoriteApi.deleteFavorite
          : MyFavoriteApi.addFavorite;
        const {result, message} = await favoriteAction(streamerId);

        throwToast(message);
        setIsFavorite((prev) => !prev);
      } catch (e) {}
    }

    setOpenIct(false);
  };

  useOutsideClick(iconRef, handleClickOutside);

  useEffect(() => {
    if (openIct) {
      MyFavoriteApi.getIsFavorite(streamerId)
        .then((isFavorite) => {
          setIsFavorite(isFavorite);
        })
        .catch(console.error);
    }
  }, [openIct, streamerId]);

  return (
    <div className='icon-menu' ref={iconRef}>
      <button
        className='bj_bs'
        tip='방송국'
        onClick={() => goToChannelViaAppScheme(streamerId)}>
        <span>방송국 가기</span>
      </button>
      <button
        className={isFavorite ? 'favor on' : 'favor'}
        tip={isFavorite ? '즐겨찾기 제거' : '즐겨찾기 추가'}
        onClick={onClickfavoriteBtn}>
        <span>즐겨찾기</span>
      </button>
    </div>
  );
};

export default StarRankMobileContextMenu;
